interface ISiteElementHtmlViewConfig {
    actionLink: IActionLink;
}

class SiteElementViewFile
    extends QueryElement<HTMLElement> {
    
    private _card: SiteCard;
    private _model: { provider: string, id: any };

    constructor(
        card: SiteCard,
        elem: HTMLElement) {

        super(elem);
        let path = this.getAttr('data-path');

        this._card = card;
        this._model = card.Model.get((path && SiteModel.split(path)) || []);

        var test = JSON.stringify(this._model);

        QueryElement.QueryElement("embed")
            .setAttr("width", "100%")
            .setAttr("height", "100%")
            .setAttr("type", "application/pdf")
            .setAttr("src", `/Api/FileGet/${btoa(test)}`)
            .appendTo(this);
    }
    
    async remove(removeInner = true) {
        await super.remove(removeInner);
    }
}